import styled from 'styled-components';
import device, { pageMaxWidth } from '../../../mediaQueries';

const LinkGroupWrapper = styled.div`
  display: flex;
  max-width: ${pageMaxWidth};
  ${device.desktop`
    justify-content: space-around;
    margin: auto;
  `}
  ${device.mobile`
    flex-direction: column;
  `}
`;

export default LinkGroupWrapper;
